// extracted by mini-css-extract-plugin
export default {"snowContainer":"Snow_snowContainer__mebxU","snowflake":"Snow_snowflake__rRM8K"};